/**
 * This is currently here as a placeholder for future functionality which properly
 * deals with error conditions.
 * Ie - logs error with sentry, and displays a message to the user before triggering
 * a reload of the whole page.
 * In the meantime, just use this in place console.log for any error conditions.
 * @url https://locale-uk.atlassian.net/browse/LPD-2834
 * @param message
 * @param data
 */
export const globalErrorCondition = (message, data) => {
    console.log(message, data);
}

export const getError = (errors, name, namePrefix = '') => {
    if (!errors || errors.length < 1) {
        return '';
    }

    let fieldName = namePrefix + name;
    if (errors.hasOwnProperty(fieldName)) {
        let error = errors[fieldName];

        return (error instanceof Array)
            ? error[0]
            : error;
    }
    return '';
}

export const getErrorsArray = (errors, names, namePrefix) => {
    if (!errors || Object.keys(errors).length < 1) {
        return [];
    }

    let output = [];
    for (var i in names) {
        if (!names.hasOwnProperty(i)) { continue; }
        output.push(getError(errors, names[i], namePrefix))
    }
    return output;
}

/**
 * Retrieves errors from an error object that match the given name prefix.
 * For example, with an error object like:
 * { 'configs[0].name': 'Name error 1', 'configs[1].name': 'Name error 2'}
 * Passing the namePrefix of 'configs[0].' will return an object like:
 * { 'name': 'Name error 1' }
 * (this is with stripPrefix = true
 *
 * @param errors
 * @param namePrefix
 * @param stripPrefix       Remove the prefix from the error id before returning
 * @returns {{}|null}
 */
export const getErrorsFor = (errors, namePrefix, stripPrefix = false) => {

    if (!errors || errors.length < 1) {
        return {};
    }

    let output = {};

    for (var i in errors) {
        if (!errors.hasOwnProperty(i)) { continue; }
        if (!i.startsWith(namePrefix)) { continue; }
        if (stripPrefix) {
            output[i.replace(namePrefix, '')] = errors[i];
        } else {
            output[i] = errors[i];
        }
    }

    if (Object.keys(output).length) {
        return output;
    } else {
        return {};
    }
}

export const combineErrors = (errors) => {
    if (!errors) {
        return '';
    }
    let filteredErrors = errors.filter(item => !!item);

    return filteredErrors.join('. ')
}

